import log from '../../../utils/ClientLogger';
import { EMAIL_DUP_ERROR_MESSAGE, EMAIL_DUP_PUPS_ERROR_MESSAGE, PHONE_VALIDATION_ERROR_MESSAGE } from '../../../constants/common';
import { createImpressionEvent, createOutcomeEvent } from '../../../utils/EventProviders/EgClickstreamUtil';
import { ELIGIBILITY_REJECT } from '../../../utils/SalesForceUtil';
import reasons from '../../../components/ListYourPropertyPage/EligibilityCatch/reasons';
import { LEAD_PAGE } from '../../../components/PageFlow/PageList';

const onError = props => (error) => {
    const {
        onSubmitError,
        setCreateAccountFail,
        // add trigger in parent props
        trigger
    } = props;

    let logLevel = 'error';
    let logEvent = 'LeadFormSubmit-Error';

    switch (error.message) {
    case EMAIL_DUP_PUPS_ERROR_MESSAGE:
    case EMAIL_DUP_ERROR_MESSAGE:
    case PHONE_VALIDATION_ERROR_MESSAGE:
        logLevel = 'info';
        logEvent = 'LeadFormSubmit-Info';
        break;
    default:
        break;
    }
    log(logLevel, logEvent, {
        message: error.message
    });
    trigger('outcome', createOutcomeEvent('user_account_creation.failed', 'LeadCapture', 'CreateAccount'));
    setCreateAccountFail(error.message);
    onSubmitError(error.message);
};

const onComplete = props => ({ data }) => {
    const {
        address,
        latLngDetails,
        pageFlow,
        // functions
        setUserId,
        setPasswordServerValidation,
        setCreateAccountSuccess,
        setEligibilityStatus,
        setJoinId,
        setPropertyId,
        // add trigger in parent props
        trigger,
        clearCompetitorUrl,
        clearSubmarketId
    } = props;
    const {
        type: contactType, lpsContact, rejectedReason
    } = data.createContact;
    clearSubmarketId();
    switch (contactType) {
    case ELIGIBILITY_REJECT:
        if (rejectedReason === reasons.PASSWORD) {
            trigger('impression', createImpressionEvent('error_message.presented', 'Leadcapture', 'PasswordInsecure'));
            setPasswordServerValidation(false);
            return;
        }
        setEligibilityStatus(rejectedReason);
        pageFlow.next(LEAD_PAGE);
        break;
    case 'HOTELIER':
        setJoinId(lpsContact.joinId);
        setPropertyId(lpsContact.propertyId);
        setUserId(lpsContact.userId);
        clearCompetitorUrl();
        trigger('outcome', createOutcomeEvent('user_account_creation.succeeded', 'LeadCapture', lpsContact.joinId, lpsContact.userId, '1.3.0', {
            event: {
                action_reason: latLngDetails.fuzzy ? 'fuzzy' : 'nonfuzzy',
                // eslint-disable-next-line eqeqeq
                action_location: `${latLngDetails.longitude == 0 ? '0/0' : 'latlng'} | ${address.country}`
            }
        }));
        pageFlow.next(LEAD_PAGE);
        break;
    default:
        throw new Error(`Unknown contactType '${contactType}' returned by service`);
    }
    setCreateAccountSuccess();
};
export default {
    onError,
    onComplete
};
